import * as Redux from 'redux'
import * as App from '../../app'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as HomeConstants from '../../pages/home/constants'
import * as Request from '../../request'
import * as CommunityTypes from '../community-config/types'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

interface RatePostPayload
  extends Request.RequestOptions { payload: {rating: number } }

type RatePostAction = Request.RequestAction<RatePostPayload>

export type RatePostActionCreator =
  (postId: number, rating: number) => RatePostAction

export const ratePost = (postId: number, rating: number) =>
    Request.requestActionCreator(Constants.RATE_POST)
    ({url: `/posts/${postId}/feedback`, method: 'PUT', payload: {rating}})

const postsUrlFor = (
  community: CommunityTypes.CommunityIdentifier,
  viewState: Types.QueryState,
): string => {
  const selectMode = viewState.dateSelect || Constants.DATE_SELECT_LAST_NEWSBRIEF_MODE
  const pageNumber = viewState.pageNumber ? viewState.pageNumber : 0
  let sortBy = viewState.sortBy
  const sortDir = viewState.sortDir
  if (sortBy === 'created_datetime') {
    sortBy = 'created'
  } else if (sortBy === 'subscription_type_sortable') {
    sortBy = 'subscription_type'
  }
  return `${Constants.SERVER_RESOURCE}/${community}/last_newsbrief` +
    `?status=${viewState.filter}&m=${selectMode}` +
    `&start=${pageNumber}&limit=${Constants.SERVER_PAGE_SIZE}&sort_by=${sortBy}&sort_dir=${sortDir}`
}

export const fetchPosts = (
  community: CommunityTypes.CommunityIdentifier,
  viewState: Types.QueryState,
) => Request.requestActionCreator(Constants.FETCH_POSTS)
({
  method: 'GET',
  url: postsUrlFor(community, viewState),
})

export const fetchRecentIssues = (
  community: CommunityTypes.CommunityIdentifier,
  viewState: Types.QueryState,
) => Request.requestActionCreator(Constants.FETCH_RECENT_ISSUES)
  ({
    method: 'GET',
    url: `${HomeConstants.SERVER_RESOURCE}/${community}/recent_issues`,
  })

export const update = (community: string, change: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_POST)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(change),
    url: `${Constants.SERVER_RESOURCE}/${community}/${change.id}`,
  })

export type ToggleModal = Modal.Toggle
export const closeModal: ToggleModal = Modal.closeModal(Constants.ADD_POST)

export const [FormActions, FormConstants] = Form.createMaps(Constants.POST_FORM)

type EditModalAction = (post: Types.Post, editType: string) => Form.EnterAction<Types.FormFields>
export const onEdit: EditModalAction = (post: Types.Post, editType: string) => FormActions[Form.ENTER](
  Utils.asFormFields(post),
)

export type CreatePostActionCreator = (community: App.SelectedCommunity, data: Types.Post) => Redux.Action
export const create: CreatePostActionCreator = (community, data) =>
  Request.requestActionCreator(Constants.ADD_POST)({
    method: 'POST',
    payload: {
      ...data,
      content_type: Constants.CONTENT_TYPE,
    },
    url: `${Constants.SERVER_RESOURCE}/${community}`,
  })

export type OpenModalAction = () => Form.EnterAction<Types.FormFields>
export const onOpen: OpenModalAction = () => FormActions[Form.ENTER]({
  ...Constants.emptyFormField,
})

export const updateUI = (viewState: any) => ({
  dateSelect: viewState.dateSelect,
  filter: viewState.filter,
  sort: viewState.sort,
  type: Constants.SELECT_POSTS_DATE_RANGE_AND_FILTER,
})

export interface PostsServerSortAction extends Redux.Action { options: any, sort?: any }
type PostsServerSortFn = (options: any) => PostsServerSortAction
export const sortPosts: PostsServerSortFn =  (options: any) => ({type: Constants.POSTS_SERVER_SORT, options})



// WEBPACK FOOTER //
// ./src/pages/posts/actions.ts